import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { reducer as notificationsReducer } from 'reapop'
// import authReducer from 'Features/user/reducer'
import uiReducer from './features/ui/reducer'
import roomsReducer from './features/rooms/reducer'
import roomsReducerFloor from './features/floors/reducer'
import amenityReducer from './features/amenity/reducer'
import userReducer from './features/user/reducer'
import usersReducer from './features/users/reducer'
import eventsReducer from './features/events/reducer'
import mybookingReducer from './features/mybookings/reducer'
import amenityserviceReducer from './features/amenityandservice/reducer'
import orderReducer from './features/orders/reducer'
import foodsReducer from './features/foods/reducer'
import qrcodeReducer from './features/qrcode/reducer'

export default combineReducers({
    form: formReducer,
    notifications: notificationsReducer(),
    auth: userReducer.auth,
    ui: uiReducer,
    rooms: roomsReducer.rooms,
    roomssuggest: roomsReducer.roomssuggest,
    roomsfirstsuggest: roomsReducer.roomsfirstsuggest,
    slots: roomsReducer.slots,
    floors: roomsReducerFloor.floors,
    roomType: roomsReducer.roomType,
    roomFormat: roomsReducer.roomFormat,
    roomInfo: roomsReducer.roomInfo,
    formSuggest: roomsReducer.formSuggest,
    formSearchName: roomsReducer.formSearchName,
    settings: roomsReducer.settings,
    floorInfo: roomsReducerFloor.floorInfo,
    amenities: amenityReducer.amenities,
    users: usersReducer.users,
    hasSendReport: userReducer.hasSendReport,
    lastusers: userReducer.lastusers,
    userInfo: userReducer.userInfo,
    eventinfo: eventsReducer.events,
    logTitle: eventsReducer.logTitle,
    eventIncoming: mybookingReducer.eventIncoming,
    eventHistory: mybookingReducer.eventHistory,
    eventCalendar: mybookingReducer.eventCalendar,
    amenityActive: amenityserviceReducer.amenityActive,
    amenityPast: amenityserviceReducer.amenityPast,
    amenityNext: amenityserviceReducer.amenityNext,
    foodActive: amenityserviceReducer.foodActive,
    foodPast: amenityserviceReducer.foodPast,
    foodNext: amenityserviceReducer.foodNext,
    orderLogAmenityList:amenityserviceReducer.orderLogAmenityList,
    orderLogFbsList:amenityserviceReducer.orderLogFbsList,
    orders: orderReducer.orders,
    orderInfo: orderReducer.orderInfo,
    foods: foodsReducer.foods,
    qrcode: qrcodeReducer.qrcode,
    sendMailResetPassword: userReducer.sendMailResetPassword,
    sendMail: userReducer.sendMail,
    orderInfoService: amenityserviceReducer.orderInfoService,
    orderAmenityList: amenityserviceReducer.orderAmenityList,
    orderFbsList: amenityserviceReducer.orderFbsList,
    checkCanBook: qrcodeReducer.checkCanBook
})



// WEBPACK FOOTER //
// ./src/reducers.js